import React from "react";
import { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import Button from "react-bootstrap/Button";
import { useAuthContext } from "../../hooks";
import { useNavigate, useParams } from "react-router-dom";
import { ViewOrgProjectsSc } from "./index.sc";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { createOrgProjectMember } from "../../api/project/createOrgProjectMember";
import { getUsers } from "../../api/users/getUsers";
import { getOrgProjectRoles } from "../../api/project/getOrgProjectRoles";
import { getOrgProjectDetails } from "../../api/project/getOrgProjectDetails";
import ProjectDetails from "../../Components/ProjectDetailCard";
import ProjectMemberCard from "../../Components/ProjectMemeberCard";
import deleteOrgProjects from "../../api/project/deleteProjects";
import DeleteProjectsModal from "./Components/ProjectsDeleteModal";
import deleteProjectMember from "../../api/project/Delete/deleteProjectMember";



function Index() {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [orgProject, setOrgProject] = useState<any>([]);
  const fetchOrgProjectDetails = async () => {
    if (!params?.projectId) return;
    setOrgProject(
      await getOrgProjectDetails(auth?.userInfo?.orgs[0]?.id, params?.projectId)
    );
    console.log("works");
  };

  console.log("org project", orgProject);
  console.log("i am here", params?.projectId);
  const refreshFunc = async () => {
    fetchOrgProjectDetails();
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [Member, setMember] = useState<any[]>([]);
  const [projectRoles, setProjectRoles] = useState<any[]>([]);


  const fetchAllMembers = async () => {
    await getUsers(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        setMember(e);
      })
      .catch((e) => console.log(e));
  };
  const fetchOrgProjectRoles = async () => {
    await getOrgProjectRoles(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        setProjectRoles(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchAllMembers();
    fetchOrgProjectRoles();
    fetchOrgProjectDetails();
  }, []);
  const auth = useAuthContext();
  const handleCreateProjectMember = async (e: any) => {
    console.debug("data > ", e);
    await createOrgProjectMember(
      auth?.userInfo?.orgs[0]?.id,
      {
        ...e,
        added_by: (auth?.userInfo?.orgs_user_id[0]).toString(),
      },
      params?.projectId
    )
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
    fetchOrgProjectDetails();
  };
  const onSubmit = async (e: any) => {
    console.log(e);
    reset();
    handleCreateProjectMember(e);
    setShow(false);
  };
  const [deleteProjectModal, setDeleteProjectModal] = useState<any>([]);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);

  const [deleteData, setDeleteData] = useState<any>([]);
  function handleShow2(data: any) {
    setShow2(true);
    setDeleteData(data);
  }
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);

  // const handleShow2 = () => setShow2(true);
  const onClickFunc = () => {
    fetchAllMembers();
    fetchOrgProjectDetails();
    setShow2(false);
  };
  const [memberNames, setMemberNames] = useState<{ data: any }[]>([]);

  // const handleClickFunc = (data: any) => {
  //       const newMemberNames = [...memberNames, data?.member_id];
  //   setMemberNames(newMemberNames);
  // };

  const handleClickFunc = (data: any) => {
  setMemberNames([data?.member_id])
  };



  const deleteProjectFunc = async () => {
    // if (!params?.projectId) return;
    await deleteOrgProjects(
      auth?.userInfo?.orgs[0]?.id,
      params?.projectId
    ).then(() => {
      setDeleteProjectModal(false);
      navigate(`..`);
    });
  };

  const deleteProjectMemberFunc = async () => {
    await deleteProjectMember(
      auth?.userInfo?.orgs[0]?.id,
      params?.projectId,
      // memberNames
      memberNames[0]

    );
    setShow2(false);
    console.log("hello delete prohect memeber works");
    fetchOrgProjectDetails();
    fetchAllMembers()
  };

  console.log("------Consoledd vlaues", memberNames?.[0]);



  return (
    <>
      <ViewOrgProjectsSc>
        <div className="create-delete-project">
          <Button
            variant="primary"
            className="create-member"
            onClick={handleShow}
          >
            Add Team Member
          </Button>
          <div>
            <Button
              variant="danger"
              className="btn-delete"
              onClick={handleShow1}
            >
              Delete Project
            </Button>
          </div>
        </div>
        <Modal show={show} onHide={handleClose} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Add Project Memeber</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit(onSubmit)}>
              <label>Member Name</label>
              <select
                {...register("org_user_id", {
                  required: {
                    value: true,
                    message: "This is required",
                  },
                })}
              >
                <option disabled value="">
                  Select Member
                </option>
                {Member?.map((e, i) => {
                  return (
                    <>
                      <option value={`${e?.org_user_id}`} key={i}>
                        {e?.first_name + "" + e?.last_name}
                      </option>
                    </>
                  );
                })}
              </select>
              <label>Select role</label>
              <select
                {...register("project_role_id", {
                  required: {
                    value: true,
                    message: "This is required",
                  },
                })}
              >
                <option disabled value="">
                  Select Role
                </option>
                {projectRoles?.map((e, i) => {
                  return (
                    <>
                      <option value={`${e?.role_id}`} key={i}>
                        {e?.role_name}
                      </option>
                    </>
                  );
                })}
              </select>
              <button className="btn btn-primary my-2">Submit</button>
            </form>
          </Modal.Body>
        </Modal>
        <div className="project-details">
          <>
            {orgProject?.map((data: any) => {
              return (
                <>
                  <ProjectDetails
                    ProjectName={data.project}
                    description={data?.description}
                  />
                  <div className="member-container">
                    {data.Members?.map((data: any) => {
                      return (
                        <>
                          <ProjectMemberCard
                            memberName={data?.fname + "" + data?.lname}
                            roleName={data?.role}
                            onClick={() => {
                              handleClickFunc(data);
                              handleShow2(data);
                            }}
                          />
                        </>
                      );
                    })}
                  </div>
                </>
              );
            })}
          </>
        </div>
      </ViewOrgProjectsSc>

      <Modal show={show1} onHide={handleClose1} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Delete Project Will Delete Completely
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose1}>
              No
            </Button>
            <Button variant="danger" onClick={deleteProjectFunc}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>


      <Modal show={show2} onHide={handleClose2} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Delete will Permanently delete !{" "}
          <span style={{ fontWeight: "bolder" }}>
            {deleteData?.fname + "  " + deleteData?.lname}
          </span>{" "}
          from this project
          <Modal.Footer>
            <Button variant="danger" onClick={deleteProjectMemberFunc}>
              Delete
            </Button>
            <Button variant="secondary">No</Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>

    </>
  );
}

export default Index;
